
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: "root",
})
export class TokenService {

    private readonly USER_KEY = 'user';
    private readonly PERMISSIONS_KEY = 'permissions';
    private readonly BRANCH_KEY = 'branch';
    private readonly ROLES_KEY = 'roles';
    constructor() {
    }

    isAuthenticated(): boolean {
      return this.getUser() !== null;
    }

    setUser(user: any): void {
      localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    }

    getUser(): any | null {
      const user = localStorage.getItem(this.USER_KEY);
      return user ? JSON.parse(user) : null;
    }

    setPermissions(permissions: string[]): void {
      localStorage.setItem(this.PERMISSIONS_KEY, JSON.stringify(permissions));
    }

    getPermissions(): string[] {
      const perms = localStorage.getItem(this.PERMISSIONS_KEY);
      return perms ? JSON.parse(perms) : [];
    }

    setBranch(branch: any): void {
      localStorage.setItem(this.BRANCH_KEY, JSON.stringify(branch));
    }

    getBranch(): any | null {
      const branch = localStorage.getItem(this.BRANCH_KEY);
      return branch ? JSON.parse(branch) : null;
    }

    setRoles(roles: string[]): void {
      localStorage.setItem(this.ROLES_KEY, JSON.stringify(roles));
    }

    getRoles(): string[] {
      const roles = localStorage.getItem(this.ROLES_KEY);
      return roles ? JSON.parse(roles) : [];
    }

    clear(): void {
      localStorage.removeItem(this.USER_KEY);
      localStorage.removeItem(this.PERMISSIONS_KEY);
      localStorage.removeItem(this.BRANCH_KEY);
      localStorage.removeItem(this.ROLES_KEY);
    }

    initializeSession(data: {
      user: any;
      permissionNames: string[];
      branch: any;
      roles: string[];
    }): void {
      this.setUser(data.user);
      this.setPermissions(data.permissionNames);
      this.setBranch(data.branch);
      this.setRoles(data.roles);
    }
}
